import { render, staticRenderFns } from "./Nexus.vue?vue&type=template&id=5c20c311&"
import script from "./Nexus.vue?vue&type=script&lang=js&"
export * from "./Nexus.vue?vue&type=script&lang=js&"
import style0 from "./Nexus.vue?vue&type=style&index=0&id=5c20c311&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports